// extracted by mini-css-extract-plugin
export default {"filter-white":"Onboarding_filter-white__6BCtg","next-step":"Onboarding_next-step__Ky8OH"};